import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { ListContainerComponent } from '../../../../shared/components/list-container/list-container.component';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { ModalAction } from '../../../../shared/modals/modal-actions/modal-action.interface';
import { Sorts } from '../../../../shared/services/pagination/models/typies/sorts.type';
import { StatusTooltipComponent } from '../status-tooltip/status-tooltip.component';
import { ModalActionsComponent } from '../../../../shared/modals/modal-actions/modal-actions.component';
import { StatusPillComponent, StatusPillEnum } from '../../../../shared/components/status-pill/status-pill.component';
import { User } from '../../../../shared/models/interfaces/user.interface';
import { AvatarComponent } from '../../../../shared/components/avatar/avatar.component';
import { SortIconComponent } from '../../../../shared/components/sort-icon/sort-icon.component';

@Component({
  selector: 'l-users-table',
  standalone: true,
  templateUrl: './users-table.component.html',
  imports: [
    DatePipe,
    TooltipModule,
    ListContainerComponent,
    AvatarComponent,
    IconComponent,
    ModalActionsComponent,
    StatusPillComponent,
    StatusTooltipComponent,
    SortIconComponent,
  ],
})
export class UsersTableComponent {

  @Input({ required: true })
  public size = 10;

  @Input({ required: true })
  public page = 1;

  @Input({ required: true })
  public data: User[] = [];

  @Input({ required: true })
  public total = 0;

  @Input()
  public sort?: Sorts;

  @Input({ required: true })
  public isLoading = false;

  @Input({ required: true })
  public hasSSO = false;

  @Input({ required: true })
  public getUserStatus!: (user: User) => StatusPillEnum;

  @Input({ required: true })
  public getRowActions!: (user: User) => ModalAction[];

  @Output()
  public pageChange = new EventEmitter<number>();

  @Output()
  public sortChange = new EventEmitter<Sorts>();

}
